import { put, call, all, takeEvery, delay, select } from "redux-saga/effects";
import commonActions from "../redux/common/actions";
export function* ExternalError(result) {
  const statusCode = result?.data?.statusCode;

  if ([400, 404, 500].includes(statusCode) && result.statusCode !== 204) {
    const message = result?.data?.message || result?.data?.data?.message || "Something went wrong. Please try again.";
    // if (Array.isArray(message)) {
      
    // } else {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: message,
        }
      });

      yield delay(2000);

      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        }
      });
    // }


  }
}
export function* InternalError(err) {
  if (err.message !== "Cannot read properties of undefined (reading '0')") {
    const message = err.response?.data?.message || err.message || "Something went wrong. Please try again.";

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: message,
      }
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      }
    });
  } else {
    return;
  }

}
